import React, { useState, useRef, useEffect } from 'react';
import '../../../assets/css/school-profile-edit.css';
import { useAuthDataContext } from '../../../__providers/AuthProvider';
import Api from '../../../__helpers/api';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import Categories from './Categories'
import Success from '../../modals/Success';

//images
import profile from '../../../assets/images/test-profile-pic.jpg';
import camera from '../../../assets/images/edit-profile/camera-icon.png';
import loader from '../../../assets/images/contacts/loader.svg';

function SchoolProfileEdit() {
    const auth = useAuthDataContext();
    const laoderGif = useRef(null);
    const submitButton = useRef(null);

    const [value, setValue] = useState({
        name: null,
        public_name: null,
        phone: null,
        eik: null,
        address: null,
        city_id: null,
        picture: null,
    });

    const [cities, setSities] = useState({
        list: []
    });

    useEffect(() => {
        setValue(value => {
            return {
                ...value,
                name: auth.user.center.name,
                public_name: auth.user.center.public_name,
                email: auth.user.center.email,
                website: auth.user.center.website,
                phone: auth.user.center.phone,
                eik: auth.user.center.eik,
                address: auth.user.center.address,
                city_id: auth.user.center.city_id,
                picture: auth.user.center.avatar,
            }
        })
        let citiesUrl = 'find-city';
        Api.get(citiesUrl)
            .then(res => {
                setSities({ list: res.data });
            })

    }, [auth])

    const handleValue = e => {
        setValue({
            city_id: value.city_id,
            [e.target.name]: e.target.value,
            picture: auth.user.center.avatar,
        });

    };

    const handleChange = e => {
        setValue(value => {
            return { ...value, city_id: e.target.value }
        });
    }


    //validation states
    const initialValidations = {
        email: false,
        name: false,
        public_name: false,
        lastname: false,
        eik: false,
        address: false,
        password: false,
        successModal: false,
        successOverlay: false,
    }
    const [validations, setValidations] = useState(initialValidations)

    const handleSuccessOk = ok => {
        setTimeout(() => {
            setValidations(validations => {
                return { ...validations, successOverlay: ok }
            })
        }, 100);
        setValidations(validations => {
            return { ...validations, successModal: ok }
        })
    }

    const handleEdit = (e) => {
        laoderGif.current.style.display = 'block';
        submitButton.current.style.display = 'none';
        e.preventDefault();

        let editPrfileUrl = 'center/profile/edit';
        let data = new FormData(e.target);

        Api.post(editPrfileUrl, data)
            .then(res => {
                laoderGif.current.style.display = 'none';
                submitButton.current.style.display = 'block';
                if (res.status === 200 && res.data.success) {
                    auth.refresh()
                    setValidations(initialValidations);

                    setValidations(validations => {
                        return { ...validations, successOverlay: true }
                    })
                    setTimeout(() => {
                        setValidations(validations => {
                            return { ...validations, successModal: true }
                        })
                    }, 100);
                }
            })
            .catch(error => {
                laoderGif.current.style.display = 'none';
                submitButton.current.style.display = 'block';

                let _err = error.response;
                if (_err && _err.status && _err.status === 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        })
                    }
                    console.log(_err.data.message);
                } else {
                    if (_err && _err.data) {
                        if (_err.data.message) {
                            console.log(`1 ${_err.data.message}`);
                        } else {
                            console.log(`2 ${_err.data}`);
                        }
                    }
                }
            });
    }

    const uploadField = useRef(null);
    const handleUpload = () => {
        uploadField.current.click()
    }

    const avatar = useRef(null);

    const handelProfilePic = e => {
        let file = URL.createObjectURL(e.target.files[0]);

        setValue(value => {
            return {
                ...value,
                picture: file,
            }
        })
    }
    return (

        <main>
            <Success
                blur={validations.successOverlay}
                popup={validations.successModal}
                mainMessage="Вашите данни бяха успешно запазени!"
                secondaryMessage="Данните Ви се съхраняват според политиката за обработка на лични данни"
                acceptCallback={handleSuccessOk}
            />
            <section id="editProfileBanner">
                <div className="wrapper">
                    <div className="picture-part">
                        <picture className="profile-picture instructor-picture" onClick={handleUpload}>
                            <img src={value.picture ? value.picture : profile} alt="profile" className="profile-image" ref={avatar} />
                            <div className="photo-overlay">
                                <img src={camera} alt="camera" />
                            </div>
                        </picture>
                        <div className="picture-part-info">
                            <h2>
                                Настройка на профила
                            </h2>
                            <p>
                                От тук може да въведете допълнителна информация за Вашия учебен център.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section id="centerProfileInfo">
                <form id="profileEditForm" className="wrapper" onSubmit={handleEdit}>
                    <input type="file" ref={uploadField} hidden className="upload" name="image" onChange={handelProfilePic} />
                    <div className="data-part">
                        <div className="col left">
                            <h2>
                                Основна информация за Вашия учебен център
                            </h2>
                            <div className="row-wrapper">
                                <div className="row">
                                    <TextField
                                        id="name"
                                        label="Име на школата*"
                                        name="name"
                                        error={validations.name === true ? true : false}
                                        placeholder="Въведете име на школата"
                                        fullWidth={false}
                                        value={value.name}
                                        onChange={handleValue}
                                        disabled={true}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className="row">
                                    <TextField
                                        id="public_name"
                                        label="Име, което виждат курсистите"
                                        name="public_name"
                                        error={validations.public_name === true ? true : false}
                                        placeholder="Въведете име на школата в системата"
                                        fullWidth={false}
                                        value={value.public_name}
                                        onChange={handleValue}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>

                                <div className="row">
                                    <TextField
                                        id="eik"
                                        label="ЕИК*"
                                        name="eik"
                                        error={validations.eik === true ? true : false}
                                        placeholder="Въведете ЕИК"
                                        fullWidth={false}
                                        value={value.eik}
                                        onChange={handleValue}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className="row">
                                    <p>
                                        Град
                                    </p>
                                    <Select
                                        labelId="day-label"
                                        id="day-label"
                                        name="city_id"
                                        onChange={handleChange}
                                        value={[value.city_id]}
                                        disabled={true}
                                    >
                                        <MenuItem value="0" disabled>
                                            <em>Избор на град</em>
                                        </MenuItem>
                                        {cities.list.map(city =>
                                            <MenuItem value={city.id} key={city.id}>{city.name}</MenuItem>
                                        )}
                                    </Select>
                                </div>
                            </div>
                            <div className="row-wrapper">
                                <div className="row">
                                    <TextField
                                        id="address"
                                        label="Адрес"
                                        name="address"
                                        error={validations.address === true ? true : false}
                                        placeholder="Въведете Адрес"
                                        fullWidth={false}
                                        value={value.address}
                                        onChange={handleValue}
                                        disabled={true}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className="row">
                                    <TextField
                                        id="phone"
                                        label="Телефон"
                                        name="phone"
                                        error={validations.phone === true ? true : false}
                                        placeholder="Въведете Телефон"
                                        fullWidth={false}
                                        value={value.phone}
                                        onChange={handleValue}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className="row">
                                    <TextField
                                        id="email"
                                        label="Е-поща"
                                        name="email"
                                        error={validations.email === true ? true : false}
                                        placeholder="Въведете Е-поща"
                                        fullWidth={false}
                                        value={value.email}
                                        onChange={handleValue}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className="row">
                                    <TextField
                                        id="website"
                                        label="Уеб сайт"
                                        name="website"
                                        error={validations.email === true ? true : false}
                                        placeholder="Въведете Уеб сайт"
                                        fullWidth={false}
                                        value={value.website}
                                        onChange={handleValue}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className="col right">
                            <h2>
                                Категории в които обучавате
                            </h2>
                            <p>
                                Обучаваме категориите
                            </p>
                            <Categories />
                        </div>
                    </div>
                    <div className="save-part">
                        <p>
                            С щракването върху бутона "Запази данните" декларирате, че информацията за Вас е вярна.
                        </p>
                        <Button type="submit" form="profileEditForm" ref={submitButton} className="save-data">
                            Запази данните
                        </Button>
                        <img src={loader} alt="loader" className="loader" ref={laoderGif} />
                    </div>
                </form>
            </section>
        </main>
    )
}

export default SchoolProfileEdit;